// 图片上传
export let uploadUrl = '';
if (process.env.NODE_ENV == 'production') {
  if (process.env.VUE_APP_REALEASE === 'test') {
    uploadUrl = '//image-test.mini1.cn/api/image/uploadWeb';
  } else {
    uploadUrl = '//image-upload2.mini1.cn/api/image/uploadCommon';
  }
} else {
  uploadUrl = '//image-test.mini1.cn/api/image/uploadWeb';
}
